import React from "react";

import { StatusBanner } from "@/components/feature/StatusBanner";

/**
 * AppointmentDeleted — der Termin existiert nicht mehr. Gleiche Bauform wie die
 * Versand-Bestätigung, damit Rückmeldungen einheitlich aussehen.
 */
const AppointmentDeleted = () => (
  <StatusBanner tone="success" title="Termin gelöscht" className="mt-[1.2rem]">
    Der Termin und die zugehörigen Einladungen wurden entfernt.
  </StatusBanner>
);

export default AppointmentDeleted;
